import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'profile.page.title': {
    id: 'profile.page.title',
    defaultMessage: 'Profile | {siteName}',
    description: 'Title tag',
  },
});

export default messages;
